const SAFE_COLOR = /^#[0-9a-f]{6}$/i;

export const DEFAULT_ACCENT = "#5b4bc4";

/** Only full hex colors are accepted so registry data cannot become arbitrary CSS. */
export function validateAccentColor(value: string | null | undefined): string {
  return value && SAFE_COLOR.test(value) ? value.toLowerCase() : DEFAULT_ACCENT;
}

export function readableAccentText(hex: string): "#ffffff" | "#17141f" {
  const color = validateAccentColor(hex).slice(1);
  const red = Number.parseInt(color.slice(0, 2), 16);
  const green = Number.parseInt(color.slice(2, 4), 16);
  const blue = Number.parseInt(color.slice(4, 6), 16);
  const luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;
  return luminance > 0.58 ? "#17141f" : "#ffffff";
}
